import { type FC } from "react";

import { EmojiReactions } from "../../EmojiReactions";
import { type DataGridUser } from "../Props";
import { type TableCellValueCommonProps } from "./types";

export type TableCellValueEmojiReactionsProps = TableCellValueCommonProps & {
	currentUser?: DataGridUser | null;
};

export const TableCellValueEmojiReactions: FC<TableCellValueEmojiReactionsProps> = ({
	value,
	onChange,
	isEditable,
	currentUser,
}) => {
	return (
		<EmojiReactions
			reactionsValue={value}
			onReactionsChange={onChange}
			readonly={!isEditable}
			currentUser={currentUser ?? undefined}
			size="sm"
		/>
	);
};
